module.exports = __webpack_public_path__ + "img/train-wheels-01.0966a0f7.png";